<template>
    <modal closeMutation="SET_SHOP_ITEM_CONTRACT_MODAL">
        <div class="modal_shop_item-header">
            <div v-if="item.badge !== undefined"
                 class="modal_shop_item-badge shop_item-badge"
                 :class="'badge-'+item.badge.color"
            >
                {{this.item.badge.text}}
            </div>
            <div class="modal_shop_item-name">
                {{item.name}}
            </div>
        </div>
        <div class="modal_shop_item-description">
            {{item.description}}
        </div>
        <div class="modal_shop_item-schedules" v-if="item.schedule_templates !== null">
            <div class="modal_shop_item-schedules_item"
                v-for="schedule in item.schedule_templates" :key="schedule.id">
                {{schedule.name}}
            </div>
        </div>
        <div class="modal_shop_item-time">
            <i>
                <img src="../../assets/img/calendar.svg" alt="">
            </i>
            {{item.time}}
        </div>
        <div class="modal_shop_item-data">
            <div class="modal_shop_item-data--row">
                <div class="key">
                    Срок действия
                </div>
                <div class="value">
                    {{item.duration}}
                </div>
            </div>
            <div class="modal_shop_item-data--row">
                <div class="key">
                    Посещений
                </div>
                <div class="value">
                    {{this.visits}}
                </div>
            </div>
            <div class="modal_shop_item-data--row" v-if="item.freeze_days !== 0">
                <div class="key">
                    Заморозка
                </div>
                <div class="value">
                    {{this.freezeDays}}
                </div>
            </div>
            <div class="modal_shop_item-data--row" v-if="this.guests !== null">
                <div class="key">
                    Гостевые визиты
                </div>
                <div class="value">
                    {{this.guests}}
                </div>
            </div>
        </div>
        <div class="modal_shop_item-btn btn btn-square" @click="this.$store.commit('SET_SHOP_PAYMENT_MODAL', {'item_type': 'contract', 'data': this.item})">
            <div class="modal_shop_item-btn--text">
                Оплатить
            </div>
            <div class="modal_shop_item-btn--price">
                <div class="modal_shop_item-btn--price-old" v-if="priceSale != null && priceSale.value !== priceFull.value">
                    <currency-symbol :price="priceFull"/>
                </div>
                <div class="modal_shop_item-btn--price-new">
                    <currency-symbol :price="price"/>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../views/Modal";
    import {plural} from "../../utilities";
    import CurrencySymbol from "../CurrencySymbol";
    export default {
        name: "ShopModalContract",
        components: {CurrencySymbol, Modal},
        props: {
            item: {},
        },
        computed: {
            price: function () {
                return !this.priceSale ? this.item.price_full : this.priceSale
            },
            priceSale: function () {
                return this.item.sale_price ? this.item.sale_price : null
            },
            priceFull: function () {
                return this.item.price_full
            },
            visits() {
                return this.item.visits !== null ? plural(this.item.visits, ['посещение', 'посещения', 'посещений']) : 'неограниченно'
            },
            freezeDays() {
                return plural(this.item.freeze_days, ['день', 'дня', 'дней'])
            },
            guests() {
                return this.item.guest !== 0 ? this.item.guest + ' шт.' : null
            },
        }
    }
</script>